
import Service from '../service'

/**
 * @type {Cookie}
 */
export default class Cookie extends Service {
    constructor (options = {}) {
        super(options)
    }

    deleteAllCookies() {
        return new Promise(resolve => {
            const cookies = document.cookie.split(";")
            for (const cookie of cookies) {
                const eqPos = cookie.indexOf("=")
                const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
                document.cookie = name + "=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT"
            }
            resolve()
        })
    }
}